<!-- FORMULARIO SOBRE TI -->
<p class="text-form">Solamente los campos marcados con (*) son obligatorios.</p>
<form action="" autocomplete="off" class="form" [formGroup]="formStepDataUber">
  <!-- UBER BLOQUEADO  -->
  <div>
    <mat-label>¿Tiene cuenta en Uber? *</mat-label>
    <div class="radio-check">
      <mat-radio-group
        (change)="checkEvent()"
        aria-label="Select an option"
        formControlName="hasUber"
      >
        <mat-radio-button
          [value]="true"
          style="margin-right: 10px"
          (change)="validInputDataUber($event)"
          >Si</mat-radio-button
        >
        <mat-radio-button [value]="false" (change)="validInputDataUber($event)"
          >No
        </mat-radio-button>
        <mat-error
          *ngIf="
            formStepDataUber.controls['hasUber'].invalid &&
            formStepDataUber.controls['hasUber'].touched
          "
        >
          <span
            *ngIf="
              formStepDataUber.controls['hasUber'].errors &&
              formStepDataUber.controls['hasUber'].errors['required']
            "
            >Debe seleccionar una opción</span
          >
        </mat-error>
      </mat-radio-group>
    </div>
    <div *ngIf="dataUber === false" class="text-check">
      <p>
        Únete a Uber desde aquí:
        <button
          id="boton-uber-create-account"
          type="button"
          class="boton-siguiente"
          (click)="openDialogUberCreateAccount()"
        >
          Uber
        </button>
        .
      </p>
    </div>
    <div *ngIf="dataUber === true" class="text-check">
      <p>Permite que Vemo pueda acceder a tus datos de UBER</p>
      <button
        id="boton-uber"
        type="button"
        class="boton-siguiente"
        (click)="openDialogUber(); clicked = true"
        [disabled]="clicked"
      >
        <img src="assets/images/iconoUber.png" /> Conectar a Uber
      </button>
    </div>
  </div>
  <div *ngIf="dataUber === false">
    <p>
      Debes tener un perfil de Uber activo para poder continuar. Si aún no lo
      tienes, haz click en el botón de Uber para iniciar tu proceso. Los
      documentos necesarios son:
    </p>
    <ul>
      <li>Identificación oficial.</li>
      <li>Licencia de conducir.</li>
      <li>Certificación de seguridad.*</li>
    </ul>
    <p>
      *La certificación consta de un examen psicométrico y una revisión de tus
      antecedentes automovilísticos y penales. Está certificación tiene un costo
      que se te descontará en la plataforma una vez que hayas sido contratado
      por VEMO Conduce.
    </p>
  </div>
</form>
